import { keepPreviousData, useQuery } from '@tanstack/react-query';

import type { DomainListShopPropertiesResponse, Shops } from '@/Swagger';
import axiosInstance from '@/axios/axios';

/**
 * property를 호출합니다.
 * PropertyProvider에서 사용
 */
export default function useGetProperties(groupCode: string, subGroupCodes?: string[]) {
  return useQuery({
    queryKey: ['properties', groupCode, subGroupCodes] as const,
    queryFn: async ({ queryKey: [_, group, subGroup] }) => {
      return axiosInstance
        .get<Shops.MetadataPropertiesList.ResponseBody>('/shops/metadata/properties', {
          params: {
            groupCode: group,
            ...(subGroup
              ? {
                  subGroupCodes: subGroup,
                }
              : {}),
          } as Shops.MetadataPropertiesList.RequestQuery,
        })
        .then(v => v.data);
    },
    placeholderData: previousData => keepPreviousData<DomainListShopPropertiesResponse>(previousData),
    staleTime: 60 * 60 * 1000,
    gcTime: 60 * 60 * 1000,
  });
}
